"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiHeader = void 0;
exports.ApiHeader = {
    CONTENT_TYPE: "Content-Type",
    DEVICE_TYPE: "x-hhn-device-type",
    APPLICATION_VERSION: "x-hhn-app-version",
    API_VERSION: "x-hhn-api-version",
    ORGANIZATION_ID: "x-hhn-active-org-id",
    DEVICE_TOKEN: "x-hhn-device-token",
};
